<div *ngIf="mode === 'view'">
    <mat-expansion-panel
        (opened)="expandPanel()"
        (closed)="panelOpenedState = false"
        class="expansion-panel"
        togglePosition="before"
    >
        <mat-expansion-panel-header collapsedHeight="74px" expandedHeight="48px">
            <mat-panel-title>
                <div class="service-account-title" data-automation="serviceAccountTitle">
                    <mat-icon
                        data-automation="viewPageServiceAccountStatusIndicator"
                        [ngSwitch]="serviceAccount.status"
                        alt="{{ getStatusDisplayLabel() | translate }}"
                        matTooltip="{{ getStatusDisplayLabel() | translate }}"
                    >
                        <div *ngSwitchCase="'ACTIVE'" class="status-icon active"></div>
                        <div *ngSwitchCase="'INACTIVE'" class="status-icon inactive"></div>
                        <div *ngSwitchCase="'PENDING'" class="status-icon pending"></div>
                        <div *ngSwitchCase="'RETIRED'" class="status-icon retired"></div>
                    </mat-icon>
                    <span class="cdk-visually-hidden">{{ getStatusDisplayLabel() | translate }}</span>
                    <ng-container>
                        <div data-automation="serviceAccountLabel" class="service-account-label">
                            {{ 'utility.account.service_account' | translate }}:
                            {{ serviceAccount.serviceAccountNumber || '-' }}
                        </div>
                    </ng-container>
                </div>
            </mat-panel-title>
            <mat-panel-description class="service-account-panel-subtitle">
                {{ panelOpenedState ? '' : getUtilityLabel() || '-' }}
            </mat-panel-description>
            <i (click)="onToggle()">
                <img class="edit-icon" id="edit_panel_{{ index }}" src="../../../assets/svg/edit-new.svg" alt="" />
            </i>
        </mat-expansion-panel-header>
        <div class="detail-row">
            <mat-label data-automation="startDateLabel" class="field-label"
                >{{ 'utility.account.start_dttm' | translate }}:</mat-label
            >
            <span data-automation="startDateValue" class="detail-value">{{ getStartDateLabel() }}</span>
        </div>
        <div class="detail-row">
            <mat-label class="field-label">{{ 'utility.account.end_dttm' | translate }}:</mat-label>
            <span data-automation="endDateValue" class="detail-value">{{ getEndDateLabel() }}</span>
        </div>
        <div class="detail-row">
            <mat-label class="field-label">{{ 'utility.account.utility_name' | translate }}:</mat-label>
            <span data-automation="utilityNameValue" class="detail-value">{{ getUtilityLabel() }}</span>
        </div>
        <div class="detail-row">
            <mat-label class="field-label">{{ 'utility.account.ecrm_id' | translate }}:</mat-label>
            <span data-automation="ecrmIdValue" class="detail-value">{{ getEcrmIdLabel() }}</span>
        </div>
    </mat-expansion-panel>
</div>
<div *ngIf="mode === 'edit'">
    <mat-expansion-panel
        class="service-account-card"
        (opened)="expandPanel()"
        (closed)="panelOpenedState = false"
        togglePosition="before"
        [class.has-error]="hasServerError"
        [expanded]="panelOpenedState"
    >
        <mat-expansion-panel-header collapsedHeight="74px" expandedHeight="48px">
            <mat-panel-title>
                <div data-automation="serviceAccountPanelTitle" class="panel-title-content">
                    <mat-icon
                        data-automation="serviceAccountStatusIndicator"
                        [ngSwitch]="serviceAccount.status"
                        alt="{{ getStatusDisplayLabel() | translate }}"
                        matTooltip="{{ getStatusDisplayLabel() | translate }}"
                    >
                        <div *ngSwitchCase="'ACTIVE'" class="status-icon active"></div>
                        <div *ngSwitchCase="'INACTIVE'" class="status-icon inactive"></div>
                        <div *ngSwitchCase="'PENDING'" class="status-icon pending"></div>
                        <div *ngSwitchCase="'RETIRED'" class="status-icon retired"></div>
                    </mat-icon>
                    <span class="cdk-visually-hidden">{{ getStatusDisplayLabel() | translate }}</span>
                    <span class="account-title" *ngIf="serviceAccount.serviceAccountNumber">
                        {{ 'utility.account.service_account' | translate }}:
                        {{ serviceAccount.serviceAccountNumber || '-' }}
                    </span>
                    <span class="account-title" *ngIf="!serviceAccount.serviceAccountNumber">
                        {{ 'utility.account.new_service_account' | translate }}
                    </span>
                </div>

                <mat-icon
                    *ngIf="!serviceAccount?.id"
                    data-automation="deleteServiceAccountIcon"
                    [ngClass]="{ 'delete-icon-enabled': true }"
                    (click)="!serviceAccount.id && onRemove($event)"
                    >delete-outlined</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description class="service-account-panel-subtitle">
                {{ panelOpenedState ? '' : getUtilityLabel() || '-' }}
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="card-content">
            <form [formGroup]="serviceAccountForm">
                <div class="form-row">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>{{ 'utility.account.service_account_number' | translate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            placeholder="{{ 'utility.account.create.placeholder.service_account_number' | translate }}"
                            formControlName="serviceAccountNumber"
                            data-automation="serviceAccountNumber"
                        />
                        <mat-error *ngIf="serviceAccountForm.get('serviceAccountNumber')?.hasError('required')">
                            {{ 'utility.account.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>{{ 'utility.account.start_dttm' | translate }}</mat-label>
                        <input
                            matInput
                            [matDatepicker]="startDatePicker"
                            placeholder="{{ 'utility.account.create.placeholder.start_dttm' | translate }}"
                            formControlName="startDate"
                            data-automation="startDate"
                            [matDatepickerFilter]="dateFilter"
                            (dateChange)="onDateChange()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker">
                            <mat-icon matDatepickerToggleIcon fontSet="material-icons-outlined"
                                >calendar_today</mat-icon
                            >
                        </mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                        <mat-error *ngIf="serviceAccountForm.get('startDate')?.hasError('required')">
                            {{ 'utility.account.validation.required' | translate }}
                        </mat-error>
                        <mat-error *ngIf="serviceAccountForm.get('startDate')?.hasError('overlappingDates')">
                            {{ 'utility.account.validation.overlapping_dates' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>{{ 'utility.account.end_dttm' | translate }}</mat-label>
                        <input
                            matInput
                            [matDatepicker]="endDatePicker"
                            placeholder="{{ 'utility.account.create.placeholder.end_dttm' | translate }}"
                            formControlName="endDate"
                            data-automation="endDate"
                            [matDatepickerFilter]="dateFilter"
                            (dateChange)="onDateChange()"
                            [errorStateMatcher]="ecrmErrorMatcher"
                        />
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker">
                            <mat-icon matDatepickerToggleIcon fontSet="material-icons-outlined"
                                >calendar_today</mat-icon
                            >
                        </mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                        <mat-error *ngIf="serviceAccountForm.get('endDate').hasError('endBeforeStart')">
                            {{ 'utility.account.validation.end_before_start' | translate }}
                        </mat-error>
                        <mat-error *ngIf="serviceAccountForm.get('endDate')?.hasError('overlappingDates')">
                            {{ 'utility.account.validation.overlapping_dates' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <input
                            data-automation="utilityField"
                            type="text"
                            placeholder="{{ 'utility.account.create.placeholder.utility' | translate }}"
                            matInput
                            formControlName="utility"
                            [matAutocomplete]="utilityAuto"
                        />
                        <mat-label>{{ 'utility.account.utility' | translate }}</mat-label>
                        <mat-autocomplete
                            data-automation="utility"
                            #utilityAuto="matAutocomplete"
                            [displayWith]="displayUtility"
                        >
                            <mat-option *ngFor="let utility of filteredUtilities | async" [value]="utility">
                                {{ utility.displayLabel }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="serviceAccountForm.get('utility')?.hasError('required')">
                            {{ 'utility.account.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>{{ 'utility.account.ecrm_id' | translate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            placeholder="{{ 'utility.account.create.placeholder.ecrm_id' | translate }}"
                            formControlName="ecrmId"
                            data-automation="ecrmId"
                            [errorStateMatcher]="ecrmErrorMatcher"
                        />
                        <mat-error *ngIf="serviceAccountForm.get('ecrmId')?.hasError('invalidEcrm')">
                            {{ 'utility.account.validation.ecrm_id' | translate }}
                        </mat-error>
                        <mat-error *ngIf="serviceAccountForm.get('ecrmId')?.hasError('duplicateInSiblings')">
                            {{ 'utility.account.validation.ecrm_id_unique' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always" [ngStyle]="{ visibility: 'hidden' }">
                        <mat-label>{{ 'utility.account.status' | translate }}</mat-label>
                        <mat-select
                            formControlName="status"
                            placeholder="{{ 'utility.account.create.placeholder.status' | translate }}"
                            data-automation="serviceAccountStatus"
                            (selectionChange)="onStatusChange($event.value)"
                        >
                            <mat-option value="ACTIVE">{{ 'utility.account.status.active' | translate }}</mat-option>
                            <mat-option value="INACTIVE">{{
                                'utility.account.status.inactive' | translate
                            }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="serviceAccountForm.get('status')?.hasError('required')">
                            {{ 'utility.account.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </mat-expansion-panel>
</div>
